import { render } from "./CommandIcon12.vue.js?vue&type=template&id=d8e7f4f4!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CommandIcon12.vue?vue&type=template&id=d8e7f4f4"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__